module.exports = __webpack_public_path__ + "static/media/2019_conf_Winning_Product_Ideas_Strategy_over_Beauty.eb60f511.png";